export const categories=[
    {
        id:1,
        title:"Mens fashion",
        img:"https://media.istockphoto.com/photos/beautiful-asian-woman-carrying-colorful-bags-shopping-online-with-picture-id1193750118?k=20&m=1193750118&s=612x612&w=0&h=w46Bjw0TuNVSKHOWtMyVIRfvzZ2JSRP4w7Zm02oqCFE=",
        cat:"men"
    },
    {
        id:2,
        title:"Women fashion",
        img:"https://images.unsplash.com/photo-1513094735237-8f2714d57c13?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=435&q=80",
        cat:"women"
    },
    {
        id:3,
        title:"footwear fashion",
        img:"https://img.freepik.com/free-photo/happy-long-haired-woman-smiling-after-shopping-portrait-pleased-white-girl-with-paper-bags_197531-8240.jpg?w=2000",
        cat:"footwear"
    }
]


export const popularProducts=[
{
   id:1,
   img:"https://static.zajo.net/content/mediagallery/zajo_dcat/image/product/types/X/9088.png"
},
{
   id:2,
   img:"https://assets.ajio.com/medias/sys_master/root/20220121/DwGv/61ea58afaeb2695cdd2436ee/-473Wx593H-461575169-maroon-MODEL.jpg"
},
{
   id:3,
   img:"https://5.imimg.com/data5/CR/OL/NO/ANDROID-36904487/img-20181220-wa0001-jpg-500x500.jpg"
},
{
   id:4,
   img:"https://lp2.hm.com/hmgoepprod?set=quality%5B79%5D%2Csource%5B%2F7a%2F0f%2F7a0fb6c70613d642ea0b57354bd8467a3f3e4bbe.jpg%5D%2Corigin%5Bdam%5D%2Ccategory%5Bmen_tshirtstanks_shortsleeve%5D%2Ctype%5BLOOKBOOK%5D%2Cres%5Bm%5D%2Chmver%5B1%5D&call=url[file:/product/main]"
},
{
   id:5,
   img:"https://assets.ajio.com/medias/sys_master/root/20210403/y4NK/6068674b7cdb8c1f14751e8f/-473Wx593H-461083532-green-MODEL2.jpg"
},
{
   id:6,
   img:"https://m.media-amazon.com/images/I/61-jBuhtgZL._UX569_.jpg"
},
{
   id:7,
   img:"https://99designs-start-attachments.imgix.net/alchemy-pictures/2016%2F01%2F26%2F21%2F38%2F27%2F9e6ce5bb-4ee0-4618-9a58-00b9d4487c0b%2F129788_Ivanpratt.png?auto=format&ch=Width%2CDPR&fm=png&w=558&h=669"
},
{
   id:8,
   img:"https://rukminim1.flixcart.com/image/332/398/kzegk280/t-shirt/n/h/l/s-t285hs-as7whdnmt-eyebogler-original-imagbfyge6kae4xg.jpeg?q=50"
}
]